import React from "react";
import DataTable from "src/components/Table";
import { StyledTableCell } from "src/components/Table/TableCell";
import TableRow from "src/components/Table/TableRow";
import { TablePriorityBadge } from "src/components/molecules/TicketsContainer/styles";
import { PriorityLevel, PriorityLevelList } from "src/types";
import { colors } from "src/styles";
import styled from "styled-components";

export type AssociatedWorkOrder = {
  id: string;
  description: string;
  priority: string;
  status: string;
  priorityId?: number;
  clientId?: string;
};

interface AssetWorkOrdersProps {
  headers: string[];
  isLoading: boolean;
  workOrders: AssociatedWorkOrder[];
  priorityLevels: PriorityLevelList;
  clientId?: string;
}

const AssetWorkOrders: React.FC<AssetWorkOrdersProps> = ({
  headers,
  isLoading,
  workOrders,
  priorityLevels,
  clientId,
}) => {
  const getPriorityColor = (workOrder: AssociatedWorkOrder) => {
    const resolvedClientId = workOrder.clientId ?? clientId;
    if (!resolvedClientId) {
      return colors.grey.default;
    }

    return (
      priorityLevels?.[resolvedClientId]?.find(
        ({ priority, name }: PriorityLevel) =>
          priority === workOrder.priorityId || name?.toLowerCase() === workOrder.priority.toLowerCase(),
      )?.color || colors.grey.default
    );
  };

  return (
    <>
      <DataTable headers={headers} isLoading={isLoading}>
        <>
          {workOrders.map((workOrder) => (
            <TableRow key={workOrder.id} $clickable={false} onClick={() => undefined}>
              <AssociatedWorkOrderCell>{workOrder.id}</AssociatedWorkOrderCell>
              <AssociatedWorkOrderCell>{workOrder.description}</AssociatedWorkOrderCell>
              <AssociatedWorkOrderCell>
                <TablePriorityBadge color={getPriorityColor(workOrder)}>{workOrder.priority}</TablePriorityBadge>
              </AssociatedWorkOrderCell>
              <AssociatedWorkOrderCell>{workOrder.status}</AssociatedWorkOrderCell>
            </TableRow>
          ))}
        </>
      </DataTable>
      {!isLoading && !workOrders.length && <EmptyTabMessage>No associated work requests found.</EmptyTabMessage>}
    </>
  );
};

const EmptyTabMessage = styled.div`
  text-align: center;
  color: #888;
  padding: 40px 0;
  font-size: 14px;
`;

const AssociatedWorkOrderCell = styled(StyledTableCell)`
  height: 50px;
  box-sizing: content-box;
  padding: 10px;
`;

export default AssetWorkOrders;
